import {
  Image,
  ResolutionUrls,
  ViewerAngleUrls,
} from '../models/utilities/images.model';

export default class Viewer360Service {
  static get360ImagesArray(resUrls: ResolutionUrls): ViewerAngleUrls[] {
    const images: ViewerAngleUrls[] = [];

    for (let i = 0; i < 36; i += 1) {
      const degrees = String(i * 10).padStart(3, '0');

      images.push({
        lowRes: { src: resUrls.lowResUrl.replace('BE040', `BE${degrees}`) },
        highRes: { src: resUrls.highResUrl.replace('BE040', `BE${degrees}`) },
      });
    }

    return images;
  }

  static getResUrls(defaultImage = ''): ResolutionUrls {
    const cleanImageUrl = Viewer360Service.cleanImageUrl(defaultImage);
    const lowResUrl = `${cleanImageUrl}${
      cleanImageUrl?.includes('width=') ? '' : '&width=300'
    }`;
    const highResUrl = lowResUrl.replace(/width=\d{3}/, 'width=800');
    return { lowResUrl, highResUrl };
  }

  static is360Image(src = ''): boolean {
    const exp = /iris\.(jpeg|jpg|png|gif)\?/;
    return !!src?.match(exp);
  }

  static cleanImageUrl(image: string): string {
    return image.split(',')[0];
  }
}
